import defaultsDeep from 'lodash/defaultsDeep'

import defaultConfig from './default'

export default defaultsDeep(
  {
    sentry: {
      enabled: true,
      environment: 'staging',
    },
  },
  defaultConfig
)
